import UltMeta, { Meta } from "./UltMeta/index";

class ProjectContractState extends UltMeta {
    TO_BE_SIGNED = new Meta(2, "待签署", "#FFBE17");
    SIGNING_IN_PROGRESS = new Meta(3, "签署中", "#FFBE17");
    COMPLETED = new Meta(4, "已完成", "#999999");
    INVALIDING = new Meta(5, "作废中", "#FFBE17");
    INVALID = new Meta(6, "已作废", "#999999");
}
export const PROJECT_CONTRACT_STATE = new ProjectContractState();

class ProjectContractDataState extends UltMeta {
    DRAFT = new Meta(1, "草稿", "color-primary");
    TO_BE_SIGNED = new Meta(2, "待签署", "color-primary");
    SIGNING_IN_PROGRESS = new Meta(3, "签署中", "color-primary");
    COMPLETED = new Meta(4, "已完成", "color-info");
    INVALIDING = new Meta(5, "作废中", "color-primary");
    INVALID = new Meta(6, "已作废", "color-info");
}
export const PROJECT_CONTRACT_DATA_STATE = new ProjectContractDataState();
